import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { DEFAULT_PROFILE_SETTINGS } from '../constants/profile-settings.ts';

import { selectProfile } from './profile.selector.ts';

export const selectIncorrectHelpThreshold = createMemoizedSelector(
  selectProfile,
  (profile): number => profile?.incorrectHelpThreshold ?? DEFAULT_PROFILE_SETTINGS.incorrectHelpThreshold
);
